import {
  PATH_STRING_SEPARATOR
} from '../common/config.js';

export class AggregateDataService {
  constructor(
    Aggregates,
    CurrentModelService,
    CurrentFilterService,
    $rootScope,
    $q,
    ErrorHandlerService,
    rx,
    loadWithCache,
    FilterResource,
    $http
  ) {
    this.Aggregates = Aggregates;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterService = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.options = ErrorHandlerService.LayoutService.options;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.loadWithCache = loadWithCache;
    this.FilterResource = FilterResource;
    this.$http = $http;

    this.prevLetter = '';
    this.aggregate = null;
    this.loading = false;
    this.loadingMore = false;
    this.isComplete = false;
    this.cancelled = false;
    this.cancelledMore = false;
    this.canceller = null;
    this.error = null;
    this.allRemoteUsers = null;
    this.remoteUsers = null;
    this.aggregareIndexObj = {};
    this.rx = rx;
    this.cancelSubject = new rx.Subject();
    this.loadMoreSubject = new rx.Subject();
    this.filterSubject = new rx.Subject();
    this.loadCheckSubject = new rx.Subject();

    this.filterData$ = this.filterSubject.asObservable()
      .filter(() => {
        if (!this.CurrentModelService.cube) {
          console.error('model is not defined');
          return false;
        }
        return true;
      })
      .map(filter => {
        if (!filter || this.$rootScope.isPdf) {
          return null;
        }
        this.filter = filter;
        this.actualFilter = filter;
        this.actualFilter.time_filter = this.options && this.options.timeRegistered && this.options.timeRegistered.value;
        const params = this.actualFilter.buildQueryParams();
        params.aggregate_order = this.CurrentFilterService.aggregateOrder;
        params.aggregate_remote = null;
        if (this.CurrentFilterService.filterBar.aggrRemote) {
          const drill = this.CurrentFilterService.filterBar.drilldown['0'];
          if (this.isAgentComputer(drill))
            params.aggregate_remote = angular.toJson(this.allRemoteUsers.map(r => [r.computer_name]));
          else if (this.isAccountUserName(drill))
            params.aggregate_remote = angular.toJson(this.allRemoteUsers.map(r => [r.user]));
        }
        return {
          filter: this.actualFilter,
          url: this.getUrl(this.actualFilter),
          params,
          lookup: this.actualFilter.lookup,
        };
      })
      .distinctUntilChanged(null, (params1, params2) => {
        let eqParams = !this.cancelled && params1 && params2 &&
          (params1.url === params2.url);
        if (!eqParams) return false;
        eqParams = Object.keys(params1.params).every(k => {
          if (k == 'page') return true;
          return angular.equals(params1.params[k], params2.params[k]);
        });
        if (params1.lookup != params2.lookup) eqParams = false;
        if (!eqParams) this.aggregate = null;
        return eqParams;
      })
      .filter(params => params)
      .switchMap(params => {
        if (this.loading || this.loadingMore) {
          this.onCancel();
        } else {
          this.page = 0;
          params.params.page = this.page;
        }
        this.beforeLoad();
        return rx.Observable.amb(
            this.cancelSubject.asObservable()
            .do(() => this.onCancel())
            .first(),
            rx.Observable.fromPromise(this.load(params))
            // .delay(10000)
            .do((data) => this.afterLoad(data))
            .catch((error) => {
              this.onError(error);
              this.error = error;
              return rx.Observable.of(null);
            }),
          )
          .flatMap(data => {
            if (data === null) {
              return rx.Observable.of(null);
            }
            return rx.Observable.merge(
                rx.Observable.of(data)
                .concat(this.loadMoreSubject.asObservable()
                  .exhaustMap(() => rx.Observable.of(null).flatMap(() => {
                    if (this.isComplete) {
                      return rx.Observable.of(null);
                    }
                    this.page += 1;
                    params.params.page = this.page;
                    this.beforeLoad();
                    return rx.Observable.amb(
                      this.cancelSubject.asObservable()
                      .do(() => this.onCancelrx.Observable.combineLatest())
                      .first(),
                      rx.Observable.fromPromise(this.load(params))
                      .do((data) => this.afterLoad(data))
                      .catch((error) => {
                        this.onError(error);
                        return rx.Observable.of(null);
                      })
                    );
                  }))
                ),
                rx.Observable.of(data)
                .concat(this.loadCheckSubject.asObservable()
                  .exhaustMap(start => {
                    const drill = params.params.drill[0];
                    if (drill !== 'agent_agent@computer_name:computer_name' &&
                      drill !== 'agent_account@user_name:user_name') return rx.Observable.of(null);

                    const newParams = angular.copy(params);
                    newParams.params.page = Math.floor(start / params.params.limit);
                    return rx.Observable.amb(
                      this.cancelSubject.asObservable()
                      .do(() => this.onCancel())
                      .first(),
                      rx.Observable.fromPromise(this.load(newParams, true))
                      .do((data) => this.updateData(data))
                      .catch((error) => {
                        this.onError(error);
                        return rx.Observable.of(null);
                      })
                    );
                  })
                )
              ).debounce(1000)
              .exhaustMap(() => this.getRemoteUsers())
              .do(() => this.markRemoteCells());
          });
      })
      .share();

    this.subscription = this.filterData$
      .subscribe(
        () => {},
      );
  }

  getRemoteUsers() {
    return this.rx.Observable.fromPromise(this.loadRemoteUsers())
      .do(response => {
        this.allRemoteUsers = response.data.map(rm => {
          if (rm.user === rm.sid) {
            if (rm.user.match(/\.\.\d+$/g)) rm.user = rm.user.match(/^.+?(?=\.\.\d+$)/g)[0];
          }
          return rm;
        });
      })
      .catch((error) => {
        this.allRemoteUsers = [];
        return this.rx.Observable.of([]);
        // return [];
      });
  }

  init(force) {
    // if (this.loading || this.loadingMore) return;
    const result = this.filterData$.first().toPromise();
    this.CurrentFilterService.filterBar.copyFrom(
      this.CurrentFilterService.filter,
      true,
    );
    this.getRemoteUsers()
      .subscribe(() => {
        if (force) {
          this.filterSubject.onNext(null);
        }
        this.CurrentFilterService.filterBar.timeFrom = this.CurrentFilterService.timeFrom;
        this.CurrentFilterService.filterBar.timeTo = this.CurrentFilterService.timeTo;
        this.filterSubject.onNext(this.CurrentFilterService.filterBar);
      });
    return result;
  }

  cancel() {
    this.cancelSubject.onNext(null);
  }

  aggregate_more() {
    this.loadMoreSubject.onNext(null);
  }

  aggregateCheck(index) {
    this.loadCheckSubject.onNext(index);
  }

  load(params, resetCache) {
    return this.loadWithCache(
      params.url,
      params.params,
      this.canceller,
      resetCache,
    );
  }

  getUrl(filter) {
    return filter.skipStat ?
      '/analytics/values/' + this.CurrentModelService.cube.name + '/' :
      '/analytics/aggregate/' + this.CurrentModelService.cube.name + '/';
  }

  onCancel() {
    if (!this.loading && !this.loadingMore || !this.canceller) {
      console.error('nothing to cancel');
      return;
    }
    this.canceller.resolve('abort');
    this.canceller = null;
    this.loading = false;
    this.loadingMore = false;
    this.isComplete = false;
    if (this.page > 0) {
      this.page -= 1;
      this.cancelledMore = true;
    } else {
      this.cancelled = true;
    }
  }

  beforeLoad() {
    if (this.loading || this.loadingMore || this.canceller) {
      console.error('load already in progress');
    }

    this.canceller = this.$q.defer();
    this.loading = this.page === 0;
    this.loadingMore = this.page !== 0;
    this.cancelled = false;
    this.cancelledMore = false;
    this.isComplete = false;
    this.error = null;
    this.$rootScope.$evalAsync(() => {});
  }

  calcEvents() {
    this.events = this.aggregate.cells.reduce((events, cell) => {
      const count = cell.record_count ? cell.record_count : 0;
      return ({
        total: events.total + count,
        max: Math.max(events.max, count),
      });
    }, {
      total: 0,
      max: 0,
    });
  }

  afterLoad(data) {
    if (!this.loading && !this.loadingMore) {
      console.error('load not in progress');
    }
    this.loading = false;
    this.loadingMore = false;
    this.canceller = null;
    //this.isComplete = data.cells.length == 0; ?? FIXED IN CUBE
    this.isComplete = data.cells.length < this.filter.limit;

    if (this.page === 0) {
      this.aggregareIndexObj = {};
      this.aggregate = data;
      this.buildIndexObj(data, 0);
    }
    this.updateData(data);
    this.calcEvents();
    this.$rootScope.$broadcast('aggregare-loaded');
    if (!this.$rootScope.$$phase) this.$rootScope.$apply();
  }

  setCellLabel(cell, drilldown) {
    cell = this.CurrentModelService.model.getCellWithLabel(
      drilldown, cell);
    if (this.isAgentComputerName(drilldown)) {
      cell.cellLabelUnic = `${cell['agent_agent.id']}${PATH_STRING_SEPARATOR}${cell['agent_agent.guid']}${PATH_STRING_SEPARATOR}${cell.cellLabel}`;
    } else cell.cellLabelUnic = cell.cellLabel;
    const letter = cell.cellLabel[0];
    cell.isFirstLetter = this.prevLetter !== letter;
    if (cell.isFirstLetter) {
      this.prevLetter = letter;
    }
  }

  buildIndexObj(data, startIndex) {
    const drill = (data.drill && data.drill[0]) || this.CurrentFilterService.filterBar.drilldown[0];
    const key = 'cellLabelUnic';
    this.prevLetter = '';
    data.cells.map((c, i) => {
      this.setCellLabel(c, drill);
      const k = c[key];
      this.aggregareIndexObj[k] = startIndex + i;
    });
  }

  updateData(data) {
    const drill = (data.drill && data.drill[0]) || this.CurrentFilterService.filterBar.drilldown[0];
    const key = 'cellLabelUnic';
    this.prevLetter = '';
    data.cells.map(c => {
      this.setCellLabel(c, drill);
      let i = this.aggregareIndexObj[c[key]];
      if (i === undefined) {
        i = this.aggregate.cells.length;
        this.aggregate.cells.push(c);
        this.aggregareIndexObj[c[key]] = i;
      } else this.aggregate.cells[i] = c;
    });
  }

  isAgentComputerName(val) {
    return val === 'agent_agent@computer_name:computer_name';
  }

  isAccountUserName(val) {
    return val === 'agent_account@user_name:user_name';
  }

  isAccountFullName(val) {
    return val === 'agent_account@full_name:full_name';
  }

  isAgentComputer(val) {
    return val.startsWith('agent_agent@');
  }

  isAgentAccount(val) {
    return val.startsWith('agent_account@');
  }

  loadRemoteUsers() {
    if (this.isAgentComputer(this.CurrentFilterService.filterBar.drilldown['0']) ||
      this.isAgentAccount(this.CurrentFilterService.filterBar.drilldown['0'])) {
      return this.$http.get('/analytics/remote_list/');
    }
    return this.$q.defer();
  }

  markRemoteCells() {
    if (!this.aggregate || !this.aggregate.cells) return;
    let predicate;
    if (this.isAccountFullName(this.filter.drilldown['0'])) predicate =
      cell => r => cell['agent_account.full_name'] === r['full_name'];
    else if (this.isAgentAccount(this.filter.drilldown['0'])) predicate =
      cell => r => cell['agent_account.user_name'] === r.user;
    else if (this.isAgentComputer(this.filter.drilldown['0'])) predicate =
      cell => r => cell['agent_agent.guid'] === r.hwid;
    else return;

    const remoteLabel = rm => {
      if (this.isAgentComputer(this.filter.drilldown['0'])) {
        return rm.full_name ? rm.full_name : rm.user;
      }
      return rm['computer_name'];
    };

    this.aggregate.cells.map(cell => {
      const rem = this.allRemoteUsers.filter(predicate(cell));
      if (rem && rem.length > 0) {
        cell.remote = rem.map(rm => ({
          label: remoteLabel(rm),
          hwid: rm.hwid,
          sid: rm.sid,
          // user: rm.full_name ? rm.full_name : rm.user,
        }));
      }
    });

  }

  updateRemoteUsers() {
    this.remoteUsers = this.allRemoteUsers.filter(u => (
      this.CurrentFilterService.filter.filters.some(f => {
        let res = false;
        if (this.isAgentComputerName(f.dimension)) {
          const values = f.value.split(PATH_STRING_SEPARATOR);
          res = values[1] === u.hwid;
          if (res && values[2]) u.computer = values[2];
        } else if (this.isAccountUserName(f.dimension)) {
          res = f.value === u.user;
        } else if (this.isAccountFullName(f.dimension)) {
          res = f.value === u['full_name'];
        }
        return res;
      })
    ));
  }

  onError(error) {
    this.loading = false;
    this.loadingMore = false;
    this.canceller = null;
    this.isComplete = false;
    if (this.page > 0) {
      this.page -= 1;
    }
    this.ErrorHandlerService.handle(error);
    // this.$rootScope.$evalAsync(() => {});
    console.error('load aggregate page', this.page, error);
  }
}



// WEBPACK FOOTER //
// ./src/core/aggregate-data.service.js